module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_21.62d0c045.png";